export enum CampaignName {
  FLASH_SALE_MYSTERY_DISCOUNT_BOX = 'FLASH_SALE_MYSTERY_DISCOUNT_BOX',
  FIRESHIP_2025 = 'FIRESHIP_2025',
}
